var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyPaste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_1486_1",
    "data-name": "Component 1486 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16000",
    "data-name": "Group 16000",
    transform: "translate(-271 -273)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8050",
    "data-name": "Rectangle 8050",
    width: 32,
    height: 32,
    transform: "translate(271 273)",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "copy",
    transform: "translate(7 6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9572",
    "data-name": "Path 9572",
    d: "M12.632,122.406H2.278A2.28,2.28,0,0,1,0,120.128V108.946a2.28,2.28,0,0,1,2.278-2.278h.414a.621.621,0,0,1,0,1.242H2.278a1.037,1.037,0,0,0-1.035,1.035v11.182a1.037,1.037,0,0,0,1.035,1.035H12.632a1.037,1.037,0,0,0,1.035-1.035v-.414a.621.621,0,1,1,1.242,0v.414A2.28,2.28,0,0,1,12.632,122.406Zm0,0",
    transform: "translate(0 -102.526)",
    fill: "#4a6df4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9573",
    "data-name": "Path 9573",
    d: "M138.975,14.91h-8.7A2.28,2.28,0,0,1,128,12.632V2.278A2.28,2.28,0,0,1,130.278,0h8.7a2.28,2.28,0,0,1,2.278,2.278V12.632A2.28,2.28,0,0,1,138.975,14.91Zm-8.7-13.667a1.037,1.037,0,0,0-1.035,1.035V12.632a1.037,1.037,0,0,0,1.035,1.035h8.7a1.037,1.037,0,0,0,1.035-1.035V2.278a1.037,1.037,0,0,0-1.035-1.035Zm0,0",
    transform: "translate(-123.03)",
    fill: "#4a6df4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyPaste);
export default __webpack_public_path__ + "static/media/CopyPaste.01d523a017bcb0106123caf8aacf8025.svg";
export { ForwardRef as ReactComponent };